import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, createUrlTreeFromSnapshot, UrlTree } from "@angular/router";
import { GrowthBookService } from "@services/growthbook/growthbook.service";

export const growthBookFeatureGuard = (route: ActivatedRouteSnapshot): boolean | UrlTree  => {
  const gbs = inject(GrowthBookService);

  if (route.data.growthBookFeature && route.data.allowedValues) {
    if (
      gbs.growthBook.isOn(route.data.growthBookFeature) &&
      route.data.allowedValues.includes(gbs.growthBook.getFeatureValue(route.data.growthBookFeature, ''))
    ) {
      return true;
    }
  }
  
  return createUrlTreeFromSnapshot(
    route.root,
    route.params.culture
  );
};
